export const userStories = {
  hu1: 'Creación de Sandbox',
  hu2: 'Generación de tabla de equivalencia bruta',
  hu3: 'Generación de vistas consumibles'
};
